import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core'

@Directive({
  selector: '[dmmpShowItemOnUpScroll]'
})
export class ShowItemOnUpScrollDirective {

  currentScrollPos = 0
  prevScrollpos = 0
  constructor(private el: ElementRef<HTMLElement>,
              private renderer2: Renderer2) { }

  @HostListener('window:scroll',  ['$event'])
  showHideHeaderOnScroll(event): void {
    this.currentScrollPos = window.pageYOffset
    if ( this.currentScrollPos > this.el.nativeElement.offsetHeight) {
      this.renderer2.removeClass(this.el.nativeElement, 'website-header--fixed')
        if (this.prevScrollpos > this.currentScrollPos) {
          this.renderer2.addClass(this.el.nativeElement, 'website-header--fixed')
          this.el.nativeElement.style.top = '0'
        } else {
          this.el.nativeElement.style.top  = `-${this.el.nativeElement.offsetHeight}px`
        }
        this.prevScrollpos = this.currentScrollPos
      } else {
      this.renderer2.removeClass(this.el.nativeElement, 'website-header--fixed')
    }
  }

}
